import { render, staticRenderFns } from "./GatewayChild.vue?vue&type=template&id=398d3042&scoped=true&"
import script from "./GatewayChild.vue?vue&type=script&lang=js&"
export * from "./GatewayChild.vue?vue&type=script&lang=js&"
import style0 from "./GatewayChild.vue?vue&type=style&index=0&id=398d3042&lang=scss&scoped=true&"
import style1 from "./GatewayChild.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398d3042",
  null
  
)

export default component.exports